import React, { Fragment, useMemo, useEffect } from 'react';
import PropTypes from 'prop-types';
import { QQShare } from '@ifeng/three_terminal/es/mobile/qqShare';
import { h5PageCount } from 'ThreeTerminal_utils';
import Grounds from 'ThreeTerminal_base/grounds';
import style from './index.css';
import RealTimeVaccinationData from './realTimeVaccinationData/realTimeVaccinationData';
import Map from './map/map';
import Trend from './trend/trend';
import AreaTable from './areaTable/areaTable';
import WakeApp from './wakeApp/wakeApp';
import { formatSumData } from '../utils/utils';
import bannerImg from '../assets/banner@2x.png';
import colorDesc from '../assets/colorDesc.png';
import shareImg from '../assets/shareImg.png';

const Layout = function Layout(props) {
    const { content } = props;
    const { area, sumData, trend, devicetype, base62Id } = content;
    const shareTitle = useMemo(() => {
        const prc = area.data.find(o => o.country === '中国');
        const usa = area.data.find(o => o.country === '美国');
        const ind = area.data.find(o => o.country === '印度');

        const { num: num0, unit: unit0 } = formatSumData(prc.total);
        const { num: num1, unit: unit1 } = formatSumData(usa.total);
        const { num: num2, unit: unit2 } = formatSumData(ind.total);

        return `全球疫苗接种进度：中国${num0}${unit0}剂，美国${num1}${unit1}剂，印度${num2}${unit2}剂`;
    }, [area.data]);

    // 页面发送统计
    const SendPageCount = function SendPageCount() {
        if (devicetype === 'share') {
            // 分享页统计
            h5PageCount([
                {
                    behavior: 'page',
                    type: 'topic',
                    other: {
                        id: `special_ucms_${base62Id}`,
                        url: encodeURIComponent(location.href),
                        ref: encodeURIComponent(document.referrer),
                    },
                },
            ]);
        } else if (devicetype === 'client') {
            Grounds.pageStat({
                id: `special_ucms_${base62Id}`,
                type: 'other',
                url: encodeURIComponent(location.href),
                ref: encodeURIComponent(document.referrer),
            });
        }
    };

    // 渲染分享组件
    const QQShareRender = function QQShareRender() {
        const qqShareCofig = {
            title: shareTitle,
            img: shareImg,
            desc: '来自凤凰新闻客户端',
            cb: () => {
                console.log('分享成功');
            },
        };

        return <QQShare content={qqShareCofig} />;
    };

    useEffect(() => {
        const ifengShareUrl = document.getElementById('ifeng_share_url');

        if (ifengShareUrl) {
            ifengShareUrl.innerText = `${ifengShareUrl.innerText}?${window.location.href.split('?')[1]}`;
            document.getElementById('ifeng_share_title').innerText = shareTitle;
        }
    }, []);

    const isShowWakeApp = !location.href.includes('from=huawei');

    return (
        <Fragment>
            {/* 顶部图片 */}
            <img className={style.bannerImg} src={bannerImg} />
            <div className={style.content}>
                {/* 实时上传数据 */}
                <RealTimeVaccinationData sumData={sumData} />
                {/* <div className={style.box}>
                    <Map area={area.data} />
                    <img className={style.colorDesc} src={colorDesc} />
                </div> */}
                {/* 累计接种趋势图 */}
                <Trend trend={trend.data} />
                <hr className={style.divider} />
                <h2 className={style.yimiaoTitle}>全球各国(地区)新冠肺炎疫苗接种情况</h2>
                <AreaTable area={area.data} />
            </div>
            {QQShareRender()}
            {SendPageCount()}
            {/* 拉活 */}
            {isShowWakeApp && <WakeApp devicetype={devicetype} />}
        </Fragment>
    );
};

Layout.propTypes = {
    content: PropTypes.object,
};

export default Layout;
